import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "hotkey-keys__range"
};
const _hoisted_2 = {
    key: 0,
    class: "hotkey-key__icon",
    viewBox: "0 0 16 16"
};
const _hoisted_3 = ["d"];
import { computed } from 'vue';
import { keysOf } from '@/client/hotkeys/hotkeyStore';
import { keyCapLabel } from '@/client/hotkeys/hotkeyEvents';
import { translateText } from '@/client/directives/i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HotkeyKeys',
    props: {
        action: {},
        fixed: {},
        always: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const keys = computed(() => props.fixed ?? (props.action !== undefined ? keysOf(props.action) : []));
        // Symbols as drawn icons: characters like ↵, ␣ or ^ sit too high or too low depending on the font; icons are always
        // centered and as heavy as the letters next to them
        const ICONS = {
            '↵': ['M13 3v5a2 2 0 0 1-2 2H3', 'M6 7l-3 3 3 3'],
            '␣': ['M2.5 7.5v3.5h11V7.5'],
            '^': ['M4 10l4-4.5 4 4.5'],
            '⌘': ['M6 6h4v4H6z', 'M6 6V4.5A1.5 1.5 0 1 0 4.5 6H6M10 6V4.5A1.5 1.5 0 1 1 11.5 6H10M6 10v1.5A1.5 1.5 0 1 1 4.5 10H6M10 10v1.5a1.5 1.5 0 1 0 1.5-1.5H10'],
            '←': ['M13 8H3', 'M7 4L3 8l4 4'],
            '→': ['M3 8h10', 'M9 4l4 4-4 4'],
            '↑': ['M8 13V3', 'M4 7l4-4 4 4'],
            '↓': ['M8 3v10', 'M4 9l4 4 4-4'],
        };
        function iconOf(key) {
            return ICONS[keyCapLabel(key)];
        }
        function capLabel(key) {
            const label = keyCapLabel(key);
            // "Ctrl" is "Strg" on German keyboards; translated like every text
            return label === 'Ctrl' ? translateText('Ctrl') : label;
        }
        return (_ctx, _cache) => {
            return (keys.value.length > 0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(['hotkey-keys', { 'hotkey-keys--always': __props.always }]),
                    "aria-hidden": "true"
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keys.value, (key, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (key === '…')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "…"))
                                : (_openBlock(), _createElementBlock("kbd", {
                                    key: 1,
                                    class: _normalizeClass(['hotkey-key', { 'hotkey-key--icon': iconOf(key) !== undefined }])
                                }, [
                                    (iconOf(key) !== undefined)
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconOf(key), (path) => {
                                                return (_openBlock(), _createElementBlock("path", {
                                                    key: path,
                                                    d: path
                                                }, null, 8, _hoisted_3));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(capLabel(key)), 1)
                                        ], 64))
                                ], 2))
                        ], 64));
                    }), 128))
                ], 2))
                : _createCommentVNode("", true);
        };
    }
});
